<template>
  <el-card>
    <div slot="header">
      <h1 class="has-operation">
        <span>视频分类管理</span>
      </h1>
    </div>

    <el-form inline :model="query" class="filter-form">
      <el-form-item>
        <router-link to="/casio-video/cate-add">
          <el-button type="primary">添加视频分类</el-button>
        </router-link>
      </el-form-item>
    </el-form>

    <el-table
      class="table block"
      :data="loadData"
      v-loading="loading"
      row-key="id"
      default-expand-all
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="name" label="分类名称" />

      <el-table-column prop="is_hot" label="是否热门">
        <template slot-scope="scope">

          <el-switch v-model="scope.row.is_hot"
            :active-value="1"
            :inactive-value="0"
            @change=" (value) => isHotChange(scope.row.id, value) "
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <router-link
            :to="{
              path: '/casio-video/cate-edit',
              query: { id: scope.row.id },
            }"
          >
            <el-link type="primary" style="margin-right: 10px">编辑</el-link>
          </router-link>

          <el-link type="primary" @click="remove(scope.row)">删除 </el-link>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("videoCategoryTree");

export default {
  data() {
    return {
      loading: true,
      query: {},
      loadData: [],
    };
  },
  computed: {
    ...mapGetters(["collection"]),
  },
  methods: {
    async queryCollection() {
      let query = {
        ...this.query,
      };

      try {
        this.loading = true;
        let data = await this.$store.dispatch("videoCategoryTree/collection", {
          query,
        });
        this.loadData = data.data;
      } finally {
        this.loading = false;
      }
    },
    async remove(cate) {
      await this.$confirm("确认删除该分类吗？");
      try {
        this.loading = true;
        await this.$store.dispatch("videoCategory/remove", cate);
        this.$message.success("删除操作完成");
      } catch (error) {
      } finally {
        this.loading = false;
        this.queryCollection();
      }
    },
    async isHotChange(id, value) {
      await this.$store.dispatch("videoCategory/update", {
        id: id,
        is_hot: value
      });
      this.$message.success("操作成功");
    }
  },
  async mounted() {
    await this.queryCollection();
    this.loading = false;
  },
};
</script>
